import { shapeAndOpenBooster1, shapeAndOpenBooster2 } from "./openBoosters";

const numCards = 16;

export function getCardImages()
{
  const cardImages = [];
  for (let i = 1; i <= numCards; i++) {
    cardImages.push(`card${i}.png`);
  }
  return cardImages;
}

export function getCollectionStorage()
{
  // Load card collection from local storage
  const storedCollection = JSON.parse(localStorage.getItem("cardCollection"));
  if (storedCollection) {
    return storedCollection;
  } else {
    // Initialize card collection if not present in local storage
    const initialCollection = Array(numCards).fill().map((_, index) => ({ index, count: 0 }));
    localStorage.setItem("cardCollection", JSON.stringify(initialCollection));
    return initialCollection
  }
}

export function OpenBooster(boosterIndex)
{
  let droppedCardIndex;
  let collection = getCollectionStorage()
  console.log({collection})
  switch (boosterIndex) {
    case 1:
        droppedCardIndex = shapeAndOpenBooster1();
        updateCollection(collection, droppedCardIndex)
        return droppedCardIndex
    case 2:
      droppedCardIndex = shapeAndOpenBooster2();
      updateCollection(collection, droppedCardIndex)
      return droppedCardIndex

    default:
      break;
  }
}

export function getTasks()
{
  const tasksList = [
    // anal
    { id: 1, image: "task1.png", score: 1, negativeScore: 10 },
    { id: 2, image: "task2.png", score: 2, negativeScore: 5 },
    { id: 3, image: "task3.png", score: 3, negativeScore: 3 },
    { id: 4, image: "task4.png", score: 5, negativeScore: 2 },

    // chastity
    { id: 5, image: "task5.png", score: 1, negativeScore: 10 },
    { id: 6, image: "task6.png", score: 2, negativeScore: 6 },
    { id: 7, image: "task7.png", score: 4, negativeScore: 3 },
    { id: 8, image: "task8.png", score: 6, negativeScore: 1 },

    // pain
    { id: 9, image: "task9.png", score: 2, negativeScore: 8 },
    { id: 10, image: "task10.png", score: 3, negativeScore: 5 },
    { id: 11, image: "task11.png", score: 5, negativeScore: 3 },
    { id: 12, image: "task12.png", score: 7, negativeScore: 1 },
  ];
  return tasksList;
}

export function getTasksPull(){
  const pull1 = [1,1,1,1, 2,2,2, 3,3, 4 ]
  const pull2 = [5,5,5,5, 6,6,6, 7,7, 8 ]
  const pull3 = [9,9,9,9, 10,10,10, 11,11, 12]
  const finalPull = [...pull1, ...pull2, ...pull3]
  return finalPull;
}

function updateCollection(cardCollection, droppedCardIndex)
{
  console.log({droppedCardIndex})
  console.log({cardCollection})
  console.log(cardCollection[droppedCardIndex - 1])


  cardCollection[droppedCardIndex - 1].count++; // Decrease index by 1 to match array index
  localStorage.setItem("cardCollection", JSON.stringify(cardCollection));
}

